/** angular */
import { NgModule } from '@angular/core';
/** end angular */

/** modules */
import { DsLibSharedModule } from '../../../shared/ds-lib-shared.module';
import { DsLibMaterialModule } from '../../../shared/ds-lib-material.module';
/** end modules */

/** components */
import { DsConfirmDialogComponent } from './ds-confirm-dialog.component';
/** end components */

@NgModule({
  declarations: [DsConfirmDialogComponent],
  imports: [DsLibSharedModule, DsLibMaterialModule],
  exports: [DsConfirmDialogComponent],
})
export class DsConfirmDialogModule {}
